// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/suplementos-cars/list',
    name: 'suplementos-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/Suplementos.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_suplemento_contrate_cars',
    },
  },
]

export default formTable
